
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentintelligence/privacy-policy",
      function () {
        return require("private-next-pages/contentintelligence/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contentintelligence/privacy-policy"])
      });
    }
  